<template>
  <SettingsField :label="$t('platform.payment_model')" :hint="$t('platform.card.fields.payment_model')" :error="invalid ? $t('platform.choose_paymet_model') : ''" :readonly="readonly" :readonlyValue="value && value.title">
    <custom-multiselect
      :value="value"
      :list="options"
      :allowEmpty="false"
      class="payment"
      :class="{
        disabled_cpl: !(user && user.is_cpl_payment_model_allowed),
        invalid,
      }"
      @input="$emit('input', $event)"
    >
      <template v-slot:block="props">
        <span>{{ props.value.title }}</span>
      </template>
      <template v-slot:list="props">
        <span>{{ props.value.title }}</span>
        <br />
        <small class="hint" v-if="props.value.title === 'Revshare'">
          {{ $t("platform.revshare_option") }}
        </small>
        <small class="hint" v-if="props.value.title === 'CPL'">
          {{ user && user.is_cpl_payment_model_allowed ? $t("platform.cpl_option") : $t("platform.cpl_option_ask") }}
        </small>
      </template>
    </custom-multiselect>
  </SettingsField>
</template>
<script>
import { mapGetters } from "vuex";
import SettingsField from "@/components/PlatformCard/SettingsField.vue";
import { PAYMENT_OPTIONS } from "@/components/PlatformCard/subaccountPayload";

// CPL or Revshare. Chosen once, when the platform is created.
export default {
  name: "PaymentModelField",
  components: { SettingsField },
  props: {
    value: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { options: PAYMENT_OPTIONS };
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
  },
};
</script>
<style lang="scss" scoped>
small.hint {
  color: #9b9ba4;
}

.disabled_cpl {
  &::v-deep {
    .custom-multiselect-list .custom-multiselect-list__block:first-child {
      pointer-events: none;
      cursor: not-allowed;
      background: #ededed !important;
      color: #676767 !important;
    }
  }
}
</style>
